import { css, cx } from "@emotion/css";
import {
	type ReactNode,
	useCallback,
	useLayoutEffect,
	useRef,
	useState,
} from "react";

import { useResizeObserver } from "../../../hooks/useResizeObserver";

interface ScrollShadowWrapperProps {
	children: ReactNode;
}

export const ScrollShadowWrapper = ({ children }: ScrollShadowWrapperProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const [isScrolledLeft, setIsScrolledLeft] = useState(false);
	const [isScrolledRight, setIsScrolledRight] = useState(false);
	const updateScrollState = useCallback(() => {
		if (ref.current) {
			const div = ref.current;
			const isScrolledLeftNow = div.scrollLeft > 0;

			if (isScrolledLeftNow !== isScrolledLeft) {
				setIsScrolledLeft(isScrolledLeftNow);
			}

			const isScrolledRightNow =
				div.scrollLeft < div.scrollWidth - div.offsetWidth - 1;

			if (isScrolledRightNow !== isScrolledRight) {
				setIsScrolledRight(isScrolledRightNow);
			}
		}
	}, [isScrolledLeft, isScrolledRight]);

	useResizeObserver(ref, updateScrollState);

	useLayoutEffect(() => {
		updateScrollState();
	}, [updateScrollState]);

	return (
		<div className="table-main-wrapper">
			<div
				className={cx(
					"scroll-shadow--left horizontal-scroll-shadow",
					css`
            opacity: ${isScrolledLeft ? 1 : 0};
          `,
				)}
			/>
			<div
				className={cx(
					"scroll-shadow--right horizontal-scroll-shadow",
					css`
            opacity: ${isScrolledRight ? 1 : 0};
          `,
				)}
			/>
			<div
				ref={ref}
				className="table-responsive dupa"
				onScroll={updateScrollState}
			>
				{children}
			</div>
		</div>
	);
};
